import React, { useState } from 'react'
import BottomNavigation from '../../Components/BottomNavigation/BottomNavigation'
import OrdersPrepared from '../../Components/OrdersPrepared/OrdersPrepared'
import ReceivedOrders from '../../Components/ReceivedOrders/ReceivedOrders'
import Style from './Orders.module.css'
const Orders = () => {
    const[checkTable,setCheckTable]=useState(false)
    return (
        <div className={Style.PageHolder}>
            <section className={Style.tabHolder}>
                <div className={checkTable?null:Style.onFocus} onClick={()=>setCheckTable(false)}> درخواست های جدید</div>
                <div className={checkTable?Style.onFocus:null} onClick={()=>setCheckTable(true)}>  درخواست های تایید شده</div>
            </section>
            {
                checkTable?<OrdersPrepared/>:<ReceivedOrders/>
            }
            <BottomNavigation/>
        </div>
    )
} 

export default Orders
